import { DataExportRequestTypes, DataExportTypes } from "event-definitions"
import { Feature, isEnabled } from "lib/@components/feature"
import { registerFeature } from "lib/features"
import { FeatureFlagDescription } from "./feature-flag-description"
import { ShareLinkActions } from "slot-definitions"
import { DownloadBookletRequest } from "./download-booklet-request"
import { Frag } from "lib/@components/slot/frag"
import { Secure } from "lib/authorization/secure"

export const FEATURE_FLAG_DOWNLOAD_BOOKLET = registerFeature({
    numericalId: 13,
    name: "Download PDF Booklet",
    id: "download-booklet",
    description: <FeatureFlagDescription $lazy />,
    readyForProduction: true,
})

DataExportTypes.handle(({ exportTypes }) => {
    if (isEnabled(FEATURE_FLAG_DOWNLOAD_BOOKLET)) {
        exportTypes.push({
            label: "PDF",
            shareLinkProperty: "canDownloadPDF",
            description: "A PDF Booklet of data shared",
        })
    }
})

DataExportRequestTypes.handle(({ dataExportRequestTypes }) => {
    dataExportRequestTypes.push("PDF Booklet")
})

ShareLinkActions.plug(
    <Feature feature={FEATURE_FLAG_DOWNLOAD_BOOKLET} priority={65}>
        <Secure demand="$professional-services" not fallback={<Frag />}>
            <DownloadBookletRequest />
        </Secure>
    </Feature>
)
